// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';



const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
<div class="gloader visible"></div>
<div class="goverlay"></div>
<div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
    <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
    <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>
        <div class="button--close">
            <span class="svg--fill block svg--48"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="19.25" fill="white" fill-opacity="0.2" stroke="#111827" stroke-width="1.5"></circle>
            <g clip-path="url(#clip0_1725_3881)">
            <path d="M17.3034 24.727L20.4854 21.545L23.6674 24.727C23.9856 25.0452 24.4099 25.0452 24.7281 24.727C25.0463 24.4088 25.0463 23.9846 24.7281 23.6664L21.5461 20.4844L24.7281 17.3024C25.0463 16.9842 25.0463 16.5599 24.7281 16.2417C24.4099 15.9235 23.9856 15.9235 23.6674 16.2417L20.4854 19.4237L17.3034 16.2417C16.9852 15.9235 16.561 15.9235 16.2428 16.2417C15.9246 16.5599 15.9246 16.9842 16.2428 17.3024L19.4248 20.4844L16.2428 23.6664C15.9246 23.9846 15.9246 24.4088 16.2428 24.727C16.561 25.0452 16.9852 25.0452 17.3034 24.727Z" fill="#212121"></path>
            </g>
            <defs>
            <clipPath id="clip0_1725_3881">
            <rect width="12" height="12" fill="white" transform="translate(28.9707 20.4844) rotate(135)"></rect>
            </clipPath>
            </defs>
            </svg></span>
        </div>
    </div>
</div>`;



//standard lightbox
const lightbox = GLightbox({
    lightboxHTML: customLightboxHTML,
    skin: 'standard',
});
lightbox.on('open', () => {
    $('.button--close').click(function() {
        lightbox.close();
    })
});


//standard lightbox
const faqBox = GLightbox({
    lightboxHTML: customLightboxHTML,
    skin: 'faqBox',
    selector: '.faq--lightbox',
});
faqBox.on('open', () => {
    $('.button--close').click(function() {
        faqBox.close();
    })
});

//standard lightbox
const videobox = GLightbox({
    lightboxHTML: customLightboxHTML,
    selector: '.orig--ratio--lightbox',
    skin: 'videobox',
    autoplayVideos: true,

});
$('.orig--ratio--lightbox').click(function(){
    var $trigger = $(this).find('.iframe--video');
    var thisID = $trigger.attr('id');
    var isSelfHosted = $trigger.is('video');

    setTimeout(function() {
        var target = document.querySelector('.ginlined-content#' + thisID);
        if (!target) return;

        if (isSelfHosted) {
            var videoEl = target.matches('video') ? target : target.querySelector('video');
            if (videoEl) {
                videoEl.classList.remove('hidden');
                videoEl.muted = true;
                try { videoEl.load(); } catch (e) {}
                videoEl.play().catch(function () { /* browser blocked autoplay */ });
            }
        } else if ('src' in target) {
            target.src += (target.src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&muted=1';
        }
    }, 100);
})
videobox.on('open', () => {
 
        

    $('.button--close').click(function() {
        videobox.close();
    })
});


//search box header
$(document).ready(function() {

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });





    const serviceBox = GLightbox({
        lightboxHTML: customLightboxHTML,
        touchNavigation: false,
        // touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".service--lightbox",
        zoomable: false,
        draggable: false,
        skin: 'services',
        // closeOnOutsideClick: true,
        // dragToleranceY: 50
    });
    serviceBox.on('open', () => {
        resizeGlightboxContainer();

        $('.button--close').click(function() {
            serviceBox.close();
        })
    });
});


if ($('.service--lightbox')[0]) {
    $(window).on('resize', function () {
        resizeGlightboxContainer();
    });
}
function resizeGlightboxContainer() {
    var newHeight = window.innerHeight;
    $('.ginner-container').css('max-height', newHeight );
}